define(function (require, exports, module) {
    let Config = require("../../Config/Config");

    let lazyload = {
        init: function (opt) {
            let that = this;
            let op = {
                anim: true,
                root: null //jquery对象,配置后查找当前对象下的img标签
            };
            $.extend(op, opt);
            that.img.init(op);
        },
        img: {
            init: function (n) {
                function inViewport(el) {
                    let scroll_top;
                    if (document.documentElement && document.documentElement.scrollTop) {
                        scroll_top = document.documentElement.scrollTop;
                    } else if (document.body) {
                        scroll_top = document.body.scrollTop;
                    }

                    let top = scroll_top;
                    let btm = scroll_top + document.documentElement.clientHeight;
                    let elTop = $(el).offset().top;

                    let elBtm = elTop + $(el).height();
                    return elBtm >= top - 300 && elTop <= btm + 300;
                }

                $(window).scroll(function () {
                    let lazyObj = $("img.lazy[data-original]").not("[loaded]");
                    if (n.root != null) {
                        lazyObj = n.root.find("img.lazy[data-original]").not("[loaded]");
                    }
                    lazyObj.each(function (index, node) {
                        let $this = $(this);
                        if ($this.hasClass('hideImg')) {
                            return;
                        }
                        if (!inViewport(this)) {
                            return;
                        }
                        act($this);
                    });
                }).trigger('scroll');

                function act(_self) {
                    let img = new Image();
                    let original = _self.attr('data-original');

                    if(original.indexOf("360buyimg") > -1) {
                        if(Config.isSupportWebP && _self.hasClass("useWebP")) {
                            if(original.indexOf(".jpg") > 0) {
                                original = original.replace(/.jpg$/, ".jpg!q90.webp");
                            } else if(original.indexOf(".png") > 0) {
                                original = original.replace(/.png$/, ".png.webp");
                            }
                        } else {
                            original = original.replace(/.jpg$/, ".jpg!q90");
                        }
                    }

                    img.onload = function() {
                        _self.attr('src', original).removeClass('lazy');
                        n.anim && _self.css({
                            opacity: .2
                        }).animate({
                            opacity: 1
                        }, 280);
                    };
                    try {
                        if(original) {
                            img.src = original;
                        }
                    } catch(error){}

                    _self.attr('loaded', true);
                }
            }
        }
    };
    exports.fn = lazyload;
});



// WEBPACK FOOTER //
// ./src/js/unit/lazyload/lazyload.js